import { useState, useEffect } from "react";
import HolidayService from "../services/holidayService";

const useHolidays = () => {
  const [holidays, setHolidays]               = useState(new Set());
  const [loadingHolidays, setLoadingHolidays] = useState(false);

  useEffect(() => {
    const fetchHolidays = async () => {
      setLoadingHolidays(true);
      try {
        const currentYear = new Date().getFullYear();
        const res = await HolidayService.GetHolidays({
          in_years: [currentYear, currentYear + 1].join(","),
          status: 1,
          limit: 999,
        });
        const results = res.data.result ?? [];
        setHolidays(new Set(results.map((h) => h.in_date?.slice(0, 10))));
      } catch (err) {
        console.error("Failed to fetch holidays", err);
      } finally {
        setLoadingHolidays(false);
      }
    };

    fetchHolidays();
  }, []);

  const isDateAvailable = (date) => {
    const yyyy = date.getFullYear();
    const mm   = String(date.getMonth() + 1).padStart(2, "0");
    const dd   = String(date.getDate()).padStart(2, "0");
    return !holidays.has(`${yyyy}-${mm}-${dd}`);
  };

  return { holidays, loadingHolidays, isDateAvailable };
};

export default useHolidays;